export class socket {
  constructor({ socket, type, payload }) {
    (this.socket = socket), (this.type = type), (this.payload = payload);
  }
  async send() {
    return new Promise((res, rej) => {
      this.socket.emit(this.type, this.payload, (response) => {
        if (response.status == "success") return res(response);
        return rej(response["error"]);
      });
    });
  }
  listen() {
    this.socket.on(this.type, (msg) => {
      return msg;
    });
  }
}
